import SuccessMessage from '@/app/components/UI/SuccessMessage'
import Head from 'next/head'

export default function SuccessPage() {
  return (
    <>
      <Head>
        <title>Azul Agro - Sucesso no Contato</title>
        <meta name="description" content="Obrigado por entrar em contato com a Azul Agro! Sua mensagem foi recebida com sucesso. Nossa equipe responderá em breve para ajudar você a otimizar suas operações agrícolas com nossas soluções de alta performance." />
      </Head>
      <main>
        <SuccessMessage />
      </main>
    </>
  )
}
